import { IconProps } from '.';

export const UncheckedSquareIcon = ({ className, color = '#808080' }: IconProps) => (
  <svg className={className} width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4.5 0.75H13.5C15.5711 0.75 17.25 2.42893 17.25 4.5V13.5C17.25 15.5711 15.5711 17.25 13.5 17.25H4.5C2.42893 17.25 0.75 15.5711 0.75 13.5V4.5C0.75 2.42893 2.42893 0.75 4.5 0.75Z' stroke={color} strokeWidth='1.5' />
  </svg>
);
